import React from 'react';
import {
  Route,
  Routes,
  useLocation
} from "react-router-dom";
import AuthenticatedApp from './components/AuthenticatedApp';
import News from './components/News';
import Login from './components/Login';
import Home from './components/Home';
import WaitingList from './components/WaitingList/WaitingList';
import WaitingListApply from './components/WaitingList/WaitingListApply';
import HandyManListView from './components/HandyManListView';
import Apartments from './components/Apartments/Apartments';
import Movers from './components/Movers/Movers';
import WaitingListApplications from './components/WaitingList/WaitingListApplications';
import HandyManList from './components/HandyMan/HandyManList';
import GeneralAssembly from './components/GeneralAssembly';
import Heating from './components/Heating';
import Settings from './components/Settings';
import './App.css';
import NewsEditorComponent from './components/NewsEditorComponent';
import WaitingListLetterEditorComponent from './components/WaitingListLetterEditorComponent';
import LetterEditor from './components/LetterEditor';
import { WaitingListApplyThankYou } from './components/WaitingList/WaitingListApplyThankYou';
import { WaitingListApplyError } from './components/WaitingList/WaitingListApplyError';
import Footer from './components/Footer';
import Handelsbetingelser from './components/Handelsbetingelser';





function App() {
  let query = new URLSearchParams(useLocation().search);

  return (
    <React.Fragment>
      <Routes>
        <Route path="/ansogventeliste" element={null} />
        <Route path="*" element={<AuthenticatedApp />} />
      </Routes>
      <Routes>
        <Route path="/nyheder" element={<News />} />
        <Route path="/ansogventeliste/tak" element={<WaitingListApplyThankYou />} />
        <Route path="/ansogventeliste/fejl" element={<WaitingListApplyError />} />
        <Route path="/ansogventeliste" element={<WaitingListApply />} />
        <Route path="/login" element={<Login />} />
        <Route path="/haandvaerkerliste" element={<HandyManListView />} />
        <Route path="/venteliste" element={<WaitingList />} />
        <Route path="/hjem" element={<Home />} />
        <Route path="/lejligheder" element={<Apartments />} />
        <Route path="/fraflyttere" element={<Movers />} />
        <Route path='/ventelisteansogninger' element={<WaitingListApplications />} />
        <Route path='/opretHaandvaerkerliste' element={<HandyManList />} />
        <Route path="/generalforsamling" element={<GeneralAssembly />} />
        <Route path="/varmeregnskab" element={<Heating />} />
        <Route path="/opretNyheder" element={<NewsEditorComponent />} />
        <Route path="/indstillinger" element={<Settings />} />
        <Route path="/waitinglistletter" element={<WaitingListLetterEditorComponent query={query} />} />
        <Route path="/letter" element={<LetterEditor query={query} />} />
        <Route path="/handelsbetingelser" element={<Handelsbetingelser />} />
        {/* <Redirect to="/nyheder"></Redirect> */}
      </Routes>
      <Footer />
    </React.Fragment>
  );
}

export default App;
